import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveShortestDistance {
  should_allow_avoid_tolls: boolean;
  should_always_find_shortest_distance: boolean;
  always_report_shortest_distance: boolean;
}

const saveShortestDistance = (postData: ISaveShortestDistance) => {
  return http().post(endpoints.companySettings.shortestDistance, postData);
};

export function useSaveShortestDistance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveShortestDistance,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });
      }
    },
  });
}
